export function fmtLBP(usd, rate) {
  const lbp = Math.round((Number(usd) || 0) * (Number(rate) || 0));
  return lbp.toLocaleString("en-US");
}

export function priceLabel(usd, rate) {
  return `$${Number(usd).toLocaleString("en-US")} · ${fmtLBP(usd, rate)} L.L.`;
}

const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const DAYS_SHORT = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const WK = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export function ymd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function buildDays(count = 21) {
  const out = [];
  const today = new Date();
  for (let i = 0; i < count; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    out.push({
      date: ymd(d),
      dayShort: DAYS_SHORT[d.getDay()],
      dayNum: d.getDate(),
      month: MONTHS[d.getMonth()],
      weekdayKey: WK[(d.getDay() + 6) % 7],
      jsDay: d.getDay(),
    });
  }
  return out;
}

export function to12h(t) {
  const [h] = t.split(":").map(Number);
  const suffix = h >= 12 ? "PM" : "AM";
  let hr = h % 12;
  if (hr === 0) hr = 12;
  return `${hr}:00 ${suffix}`;
}

export function prettyDate(ymdStr) {
  if (!ymdStr) return "";
  const [y, m, d] = ymdStr.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  return `${DAYS[dt.getDay()]}, ${MONTHS[dt.getMonth()]} ${d}`;
}
